var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextTool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.47794C0 2.44983 2.44983 0 5.47794 0H40.5221C43.5449 0 46 2.44983 46 5.47794V40.5221C46 43.5449 43.5502 46 40.5221 46H5.47794C2.45509 46 0 43.5502 0 40.5221V5.47794ZM5.47794 2.19223C3.66423 2.19223 2.19223 3.66423 2.19223 5.47794V40.5221C2.19223 42.3358 3.66423 43.8078 5.47794 43.8078H40.5221C42.3358 43.8078 43.8078 42.3358 43.8078 40.5221V5.47794C43.8078 3.66423 42.3358 2.19223 40.5221 2.19223H5.47794Z",
    fill: "#FF669B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9492 12.0484C10.9492 11.4439 11.4381 10.9497 12.048 10.9497H33.9492C34.5538 10.9497 35.048 11.4386 35.048 12.0484V16.4276C35.048 17.0322 34.559 17.5211 33.9492 17.5211C33.3394 17.5211 32.8557 17.0322 32.8557 16.4276V13.1419H24.0921V32.8562H26.2843C26.8889 32.8562 27.3778 33.3451 27.3778 33.9497C27.3778 34.5543 26.8889 35.0484 26.2843 35.0484H19.7129C19.1083 35.0484 18.6194 34.5595 18.6194 33.9497C18.6194 33.3399 19.1083 32.8562 19.7129 32.8562H21.9051V13.1419H13.1414V16.4276C13.1414 17.0322 12.6525 17.5211 12.048 17.5211C11.4434 17.5211 10.9492 17.0322 10.9492 16.4276V12.0484Z",
    fill: "#FF669B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextTool);
export default __webpack_public_path__ + "static/media/TextTool.76d7aa22ffd896b79132a44e6a7d5a6c.svg";
export { ForwardRef as ReactComponent };